import React, { useEffect, useState, createRef } from "react";
import JSZip from "jszip";
import PropTypes from "prop-types";
import { Modal, Button, Alert } from "react-bootstrap";
//import Select from "react-select";
import { useTranslation } from "react-i18next";
import Dropzone from "react-dropzone";
import * as Sentry from "@sentry/react";

/** Services */

/**Elements */
import TextLoading from "../../global/TextLoading";

export default function ModalImportProfilePhotos(props) {
  const dropzoneRef = createRef();
  const [file, setFile] = useState("");
  const [activeImport, setActiveImportButton] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState(false);
  const [t] = useTranslation(["student", "global"]);
  useEffect(() => {});

  /**
   * Initial loading
   */
  useEffect(() => {
    Sentry.setTag("section", "Import Student Modal");
  }, []);

  /**
   * Purpose: Close the "Import Students" modal
   */
  const cancel = () => {
    props.setShowImportProfilePhotos(false);
  };

  /**
   * Open File
   */
  const openFile = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.open();
    }
  };

  /**
   * import students
   */
  const loadZip = async () => {
    setActiveImportButton(true);
    setIsSaving(true);
    setErrors(false);
    if (!file || !file[0]) {
      setErrors({ description: "No se ha seleccionado ningún archivo." });
      setIsSaving(false);
      setActiveImportButton(false);
      return;
    }
    try {
      const zip = await JSZip.loadAsync(file[0]);
      // Buscar imágenes por extensión
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".bmp",
        ".webp",
      ];
      let hasImage = false;
      zip.forEach((relativePath, zipEntry) => {
        if (!zipEntry.dir) {
          const lower = zipEntry.name.toLowerCase();
          if (imageExtensions.some((ext) => lower.endsWith(ext))) {
            hasImage = true;
          }
        }
      });
      if (!hasImage) {
        setErrors({
          description:
            "El archivo ZIP no contiene ninguna imagen válida (.jpg, .jpeg, .png, .gif, .bmp, .webp).",
        });
        setIsSaving(false);
        setActiveImportButton(false);
        return;
      }
      // Si pasa la validación, continuar
      props.setImageZipFile(file);
      props.obtainImageZipFile();
      setIsSaving(false);
    } catch (err) {
      setErrors({
        description:
          "No se pudo leer el archivo ZIP. Asegúrate de que el archivo no esté dañado.",
      });
      setIsSaving(false);
      setActiveImportButton(false);
      return;
    }
  };

  return (
    <Modal
      show={props.showImportProfilePhotos}
      bsSize="large"
      aria-labelledby="contained-modal-title-lg"
    >
      <Modal.Header className="modal-header">
        <Modal.Title className="modal-title text-center">
          {t("student:ModalImportProfilePhotos.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row">
            <div className="col-md-12 textImportStudent">
              {t("student:ModalImportProfilePhotos.description")}
              <br />
              <p
                style={{
                  fontWeight: "bold",
                  fontFamily: "'Open Sans', sans-serif",
                  fontSize: "12px",
                  marginTop: "15px",
                  marginBottom: "10px",
                }}
              >
                {t("student:ModalImportProfilePhotos.note")}
              </p>
            </div>
          </div>
          <p
            style={{
              fontFamily: "'Open Sans', sans-serif",
              fontSize: "13px",
              marginBottom: "10px",
            }}
          >
            <b>{t("student:ModalImportProfilePhotos.zipLimit")}</b>
          </p>
          <div
            style={{
              position: "relative",
              height: "auto",
              borderWidth: "2px",
              borderColor: "rgb(194, 194, 194)",
              borderStyle: "dashed",
              borderRadius: "5px",
            }}
          >
            <Dropzone
              ref={dropzoneRef}
              accept={[".zip"]}
              maxSize={100 * 1024 * 1024} // 100 MB en bytes
              onDrop={(acceptedFiles, fileRejections) => {
                if (fileRejections && fileRejections.length > 0) {
                  const reason = fileRejections[0].errors[0].code;
                  let description = "";
                  if (reason === "file-invalid-type") {
                    description = "Solo se permiten archivos .zip.";
                  } else if (reason === "file-too-large") {
                    description =
                      "El archivo excede el tamaño máximo permitido de 100 MB.";
                  } else {
                    description = "Archivo no válido.";
                  }
                  setErrors({ description });
                  // props.setImageZipFile(null);
                  setFile("");
                  setActiveImportButton(true);
                } else {
                  // props.setImageZipFile(acceptedFiles);
                  setFile(acceptedFiles);
                  setErrors(false);
                  setActiveImportButton(false);
                }
              }}
              noClick
              noKeyboard
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <center>
                    <p
                      style={{
                        fontWeight: "normal",
                        fontFamily: "'Open Sans', sans-serif",
                        fontSize: "14px",
                        color: "#ea2c54",
                        paddingTop: "20px",
                        paddingBottom: "20px",
                      }}
                    >
                      {file && file[0].name
                        ? file[0].name
                        : t("student:ModalImportProfilePhotos.dragTheFile")}
                      <br />
                      <br />
                      <input {...getInputProps()} />
                      <Button
                        id="uploadStudentInformationFileBtn"
                        type="button"
                        className="btn btn-text btn-white"
                        disabled={isSaving}
                        onClick={openFile}
                      >
                        {t("student:ModalImportProfilePhotos.uploadFile")}
                      </Button>
                    </p>
                  </center>
                </div>
              )}
            </Dropzone>
          </div>
        </form>
        <br />
        {errors ? <Alert variant="warning">{errors.description}</Alert> : ""}
      </Modal.Body>

      <Modal.Footer>
        <Button
          id="cancelImportCsvStudentBtn"
          style={{ marginRight: "10px" }}
          variant="outline-secondary"
          disabled={isSaving}
          onClick={() => cancel()}
        >
          {t("global:buttons.cancel")}
        </Button>
        <Button
          id="importCsvStudentBtn"
          variant="primary"
          disabled={activeImport || isSaving}
          onClick={loadZip}
        >
          {isSaving ? (
            <TextLoading text={t("global:buttons.importing")} variant="light" />
          ) : (
            t("global:buttons.import")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalImportProfilePhotos.propTypes = {
  showImportProfilePhotos: PropTypes.bool,
  setShowImportProfilePhotos: PropTypes.func,
  setImageZipFile: PropTypes.func,
  obtainImageZipFile: PropTypes.func,
};
